<template>
  <b-container fluid>
    <b-row>
      <b-col
        cols="auto"
        :class="{
          'col-left': true,
          'my-auto': true,
        }"
      >
        {{ testSelected ? testSelected.name: null }}
      </b-col>
      <b-col
        cols="auto"
        :class="{
          'col-left': true,
          'my-auto': true,
        }"
      >
        <b-button
          size="sm"
          :class="{
            'tab-button': true,
          }"
          @click="$emit('back', 'test')"
        >
          ย้อนกลับ
        </b-button>
      </b-col>
      <b-col
        cols="auto"
        :class="{
          'col-left': true,
          'my-auto': true,
        }"
      >
        <b-button
          size="sm"
          :class="{
            'tab-button': true,
            'active': tabSelectedComputed === 'editSubTest'
          }"
          @click="$emit('input', 'editSubTest')"
        >
          ข้อมูลทั่วไป
        </b-button>
      </b-col>
      <template v-if="testSelected.has_sub_tests || testSelected.has_sub_test || testSelected.sub_test.length > 0">
        <b-col
          cols="auto"
          :class="{
            'col-left': true,
            'my-auto': true,
          }"
        >
          <b-button
            size="sm"
            :class="{
              'tab-button': true,
              'active': tabSelectedComputed === 'subSubTest'
            }"
            @click="$emit('input', 'subSubTest')"
          >
            ผลตรวจย่อย
          </b-button>
        </b-col>
        <b-col
          cols="auto"
          :class="{
            'col-left': true,
            'my-auto': true,
          }"
        >
          <b-button
            size="sm"
            :class="{
              'tab-button': true,
              'active': tabSelectedComputed === 'createSubSubTest'
            }"
            @click="$emit('input', 'createSubSubTest')"
          >
            สร้างผลตรวจย่อยใน {{ testSelected ? testSelected.name: null }}
          </b-button>
        </b-col>
      </template>
      <!--      <b-col-->
      <!--        cols="auto"-->
      <!--        :class="{-->
      <!--          'col-left': true,-->
      <!--          'my-auto': true,-->
      <!--        }"-->
      <!--      >-->
      <!--        <b-button-->
      <!--          size="sm"-->
      <!--          :class="{-->
      <!--            'tab-button': true,-->
      <!--            'active': tabSelectedComputed === 'testPrice'-->
      <!--          }"-->
      <!--          @click="$emit('input', 'testPrice')"-->
      <!--        >-->
      <!--          ราคา-->
      <!--        </b-button>-->
      <!--      </b-col>-->
      <b-col
        cols="auto"
        :class="{
          'col-left': true,
          'my-auto': true,
        }"
      >
        <b-button
          size="sm"
          :class="{
            'tab-button': true,
            'active': tabSelectedComputed === 'subTestRefRange'
          }"
          @click="$emit('input', 'subTestRefRange')"
        >
          Ref Range
        </b-button>
      </b-col>
    </b-row>
    <template v-if="tabSelectedComputed === 'subSubTest'">
      <b-row class="pt-3 mt-3 sub-panel">
        <b-col
          cols="auto"
          :class="{
            'col-left': true,
            'my-auto': true,
          }"
        >
          <b-button
            size="sm"
            :class="{
              'tab-button': true,
              'active': tabSelectedComputed === 'createSubSubTest'
            }"
            @click="$emit('input', 'createSubSubTest')"
          >
            สร้างผลตรวจย่อยใน {{ testSelected ? testSelected.name: null }}
          </b-button>
        </b-col>
        <b-col cols="auto">
          <b-row align-h="end">
            <template v-if="sequenceChange">
              <template v-if="tabSelectedComputed === 'subSubTest'">
                <b-col
                  cols="auto"
                >
                  <b-button
                    size="sm"
                    variant="success"
                    @click="updateSubSubTestsSequenceHandler"
                  >
                    บันทึกลำดับ
                  </b-button>
                </b-col>
                <b-col
                  cols="auto"
                >
                  <b-button
                    size="sm"
                    variant="danger"
                    @click="resetSubSubTestsSequenceHandler"
                  >
                    รีเซ็ตลำดับ
                  </b-button>
                </b-col>
              </template>
            </template>
          </b-row>
        </b-col>
      </b-row>
    </template>
    <template v-if="tabSelectedComputed === 'subTestRefRange' || tabSelectedComputed === 'refRangeMultiCreate'">
      <b-row class="pt-3 mt-3 sub-panel">
        <b-col cols="auto">
          <b-button
            variant="success"
            size="sm"
            @click="updateRefRangeHandler"
          >
            บันทึก
          </b-button>
        </b-col>
        <b-col cols="auto">
          <b-button
            size="sm"
            :class="{
              'tab-button': true,
              'active': tabSelectedComputed === 'refRangeMultiCreate'
            }"
            @click="$emit('input', 'refRangeMultiCreate')"
          >
            เพิ่มค่า Ref Range
          </b-button>
        </b-col>
      </b-row>
    </template>
  </b-container>
</template>

<script>
  export default {
    name: "SubTestLevelTitle",
    props: {
      value: {
        type: String,
        default: 'editTest'
      },
      testSelected: {
        type: Object,
        default: () => null,
      },
      sequenceChange: {
        type: Boolean,
        default: false
      },
    },
    computed: {
      tabSelectedComputed: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        }
      }
    },
    methods: {
      async resetSubSubTestsSequenceHandler() {
        const confirm = await this.$swal.fire({
          title: 'ยืนยันการรีเซ็ตลำดับ',
          text: "คุณต้องการรีเซ็ตลำดับผลตรวจย่อยที่ได้เปลี่ยนแปลงไปรวมถึงผลตรวจย่อยก่อนหน้านี้ใช่หรือไม่?",
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'รีเซ็ต',
          cancelButtonText: 'ยกเลิก',
        })

        if (confirm.value) {
          this.$emit('reset-sub-sub-test-sequence')
        }
      },
      async updateSubSubTestsSequenceHandler() {
        const { value: password } = await this.$swal.fire({
          title: 'กรอกรหัสผ่านเพื่อดำเนินการต่อไป',
          input: 'password',
          inputAttributes: {
            autocapitalize: 'off',
            autocorrect: 'off'
          }
        })

        if (password) {
          this.$emit('update-sub-sub-test-sequence', password)
        } else {
          return
        }

      },
      async updateRefRangeHandler() {
        const { value: password } = await this.$swal.fire({
          title: 'กรอกรหัสผ่านเพื่อดำเนินการต่อไป',
          input: 'password',
          inputAttributes: {
            autocapitalize: 'off',
            autocorrect: 'off'
          }
        })

        if (password) {
          this.$emit('update-ref-range', password)
        } else {
          return
        }

      }
    }
  }
</script>

<style lang="scss" scoped>
  .action-panel {
    opacity: 0;
    &.visible {
      opacity: 100%;
    }
  }

  .tab-button {
    &.active {
      background: #2E83D9 !important;
      color: white;
    }
  }

  .test-sequence-panel {
    border-top: 1px solid black;
  }

  .sub-panel {
    border-top: 1px solid black;
  }
</style>